import { formatNumber } from '@infinitro/global';
export function formatLargeNumbers(str1) {
    const num = Number(str1 ?? 0);
    if (num >= 1000000) {
        return formatNumber((num / 100000).toFixed(2).replace(/\.0$/, '')) + 'M';
    }
    if (num >= 1000) {
        return formatNumber((num / 1000).toFixed(2).replace(/\.0$/, '')) + 'K';
    }
    return formatNumber(num);
}
